// extracted by mini-css-extract-plugin
export default {"max_title":"ModalTitle_max_title__IQvLq","mid_title":"ModalTitle_mid_title__YYSCH","min_title":"ModalTitle_min_title__dl79b","error_text":"ModalTitle_error_text__LtgK+"};